export default function Logo({ variant = "light", size = "md" }) {
  const sizes = { sm: "h-10", md: "h-14", lg: "h-16", xl: "h-24" };
  return (
    <div className={`inline-flex items-center ${sizes[size]}`} data-testid="site-logo">
      <img
        src="/logo-volavola.webp"
        alt="Vola Vola APS — Associazione di Promozione Sociale"
        className={`${sizes[size]} w-auto object-contain shrink-0`}
      />
    </div>
  );
}
